import Logo from '../../../assets/images/SVG/logo_creative.svg'
export const AppHeader = () => {
  return (
    <>
      <div bg="white" className="navbar">
        <a href="/">
          <img
            src={Logo}
            alt=""
            className="logo"
          ></img>
        </a>
      </div>
    </>
  )
}